export const IsiClickHere = (props) => {
    return (
        <div className={`isi-click-here py-2 text-center ${props.isOpen ? "open" : "closed"}`}>
            <p style={{ fontFamily: 'Flama-Medium'}} >
                Click or scroll down to see full COSENTYX Indications & Important Safety Information.</p>
            <p  style={{ fontFamily: 'Flama-Medium'}} >Full Prescribing Information, including Medication Guide, is presented below following the Important Safety Information and can be found at COSENTYXhcp.com.
            </p>
        </div>
    )
}